import { isAthenaOneWebOrMobileClient } from '../../utils/app-utils';
import { useWidgetContext } from '../context/WidgetContext';
import MutedText from './MutedText';
import React from 'react';

export default function Footer({
  footerText,
  reactFooters,
}: {
  footerText?: string;
  reactFooters: React.ReactNode[];
}) {
  const { settings } = useWidgetContext();
  const border = settings.isAuthnWithLwaClientId && !isAthenaOneWebOrMobileClient();
  return (
    <div className={`athena-footer${border ? ' athena-footer--border' : ''}`}>
      {footerText && (
        <div className={'fe_u_font-size--small fe_u_text-align--left fe_u_margin--bottom-large'}>
          <MutedText text={footerText} />
        </div>
      )}
      {reactFooters.length > 0 && <div>{reactFooters}</div>}
    </div>
  );
}
